export enum RouteStatusEnum {
    /** Uploaded, waiting for the KML enrichment to pick it up. */
    PENDING = 'pending',
    /** Enrichment is running: HERE routing, TBT injection, reverse geocoding. */
    PROCESSING = 'processing',
    /** Enrichment finished; the route has a polyline and is usable. */
    PROCESSED = 'processed',
    /** Enrichment failed. `statusMessage` carries the reason. */
    ERROR = 'error',
}
